import "@arco-design/web-react/es/Space/style";
import _Space from "@arco-design/web-react/es/Space";
import "@arco-design/web-react/es/Button/style";
import _Button from "@arco-design/web-react/es/Button";
import "@arco-design/web-react/es/Form/style";
import _Form from "@arco-design/web-react/es/Form";
import "@arco-design/web-react/es/Input/style";
import _Input from "@arco-design/web-react/es/Input";
import "@arco-design/web-react/es/Notification/style";
import _Notification from "@arco-design/web-react/es/Notification";
import { intl } from 'di18n-react';
import React, { useRef, useState } from 'react';
import styles from './style/index.module.less';
import formStyles from '@/style/form.module.less';
import cs from 'classnames';
import { useHistory } from 'react-router';
export default function RegisterForm() {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  function login(params) {
    try {
      setLoading(true);
      // Message.success('注册成功');
      _Notification.success({
        title: intl.t('提示'),
        content: intl.t('注册成功'),
        duration: 5000
      });
      setLoading(false);
      history.push('/login');
    } catch (e) {
      setLoading(false);
    }
  }
  function onSubmitClick() {
    formRef.current.validate().then(values => {
      login(values);
    });
  }
  return /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-wrapper']
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['login-form-title']
  }, intl.t('欢迎使用AidLux NodeMaster')), /*#__PURE__*/React.createElement(_Form, {
    className: cs(styles['login-form'], formStyles.form),
    layout: "vertical",
    ref: formRef,
    requiredSymbol: false,
    colon: true
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "userName",
    label: intl.t('用户名'),
    rules: [{
      required: true,
      message: intl.t('必填项')
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    onPressEnter: onSubmitClick,
    height: 40
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "nickname",
    label: intl.t('昵称'),
    rules: [{
      required: true,
      message: intl.t('必填项')
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    onPressEnter: onSubmitClick,
    height: 40
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "password",
    label: intl.t('密码'),
    rules: [{
      required: true,
      message: intl.t('必填项')
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    onPressEnter: onSubmitClick,
    height: 40
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    field: "confirmPassword",
    label: intl.t('确认密码'),
    validateTrigger: [],
    rules: [{
      required: true,
      message: intl.t('必填项')
    }, {
      validator: (value, callback) => {
        if (value !== formRef.current.getFieldValue('password')) {
          callback(intl.t('密码不一致'));
        }
      }
    }]
  }, /*#__PURE__*/React.createElement(_Input.Password, {
    onPressEnter: onSubmitClick,
    height: 40
  })), /*#__PURE__*/React.createElement(_Space, {
    size: 20,
    direction: "vertical",
    style: {
      paddingTop: '30px'
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    long: true,
    status: "warning",
    onClick: onSubmitClick,
    loading: loading,
    className: cs(styles['login-form-btn'], styles.register)
  }, intl.t('注 册')))));
}